import axios from 'axios'
export default {
  getListAll(params) {
    return new Promise((resolve, reject) => {
      axios
        .get("punch/index/all", {
          params: params
        })
        .then((res) => {
          resolve(res.data.data)
        })
        .catch(() => {
          reject('取得打卡記錄錯誤')
        });
    })
  },
}